import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@mono/ui-components';
import { Save } from 'lucide-react';
import { SettingsSidebar } from './SettingsSidebar';
export function SettingsLayout({ activeSection, onSectionChange, hasChanges, onSave, children }) {
    return /*#__PURE__*/ _jsx("div", {
        className: "p-6",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col gap-8 lg:flex-row",
            children: [
                /*#__PURE__*/ _jsx(SettingsSidebar, {
                    activeSection: activeSection,
                    onSectionChange: onSectionChange
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex-1",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "rounded-lg border border-border bg-card p-6 shadow-sm",
                            children: children
                        }),
                        hasChanges && /*#__PURE__*/ _jsx("div", {
                            className: "mt-6 flex justify-end",
                            children: /*#__PURE__*/ _jsxs(Button, {
                                onClick: onSave,
                                children: [
                                    /*#__PURE__*/ _jsx(Save, {
                                        className: "mr-2 h-4 w-4"
                                    }),
                                    "Save Changes"
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}
